if (sessionStorage.getItem('layout-icon') != null) {
  document.querySelector('.layout-icon.active').classList.remove('active');
  console.log(  document.querySelector(`.layout-icon[data-layout="${sessionStorage.getItem('layout-icon')}"]`))
  setTimeout(() => {
    document.querySelector(`.layout-icon[data-layout="${sessionStorage.getItem('layout-icon')}"]`).click();
  },50);
}

document.querySelectorAll('.layout-icon').forEach(icon => {
  // if (innerWidth < 768 && document.body.classList.contains('template-suffix-sale-layout')) {
  //   document.querySelector('#product-grid').classList.remove('product-grid-basic');
  //   document.querySelector('#product-grid').classList.add('product-grid-6');
  //   document.querySelector('.layout-icon.layout-icon-one').classList.remove('active');
  //   document.querySelector('.layout-icon.layout-icon-two').classList.add('active');
  // }
  icon.addEventListener('click', () => {
    const productGrid = document.querySelector('#product-grid');
    ['product-grid-basic', 'product-grid-6', 'product-grid-12'].forEach(cls => {
      if (cls !== icon.dataset.layout) productGrid.classList.remove(cls);
    });
    productGrid.classList.add(icon.dataset.layout);
    sessionStorage.setItem('layout-icon',icon.dataset.layout)
    document.querySelectorAll('.layout-icon').forEach(i => i.classList.remove('active'));
    icon.classList.add('active');
  });
});
